import { createRouter, createWebHashHistory, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'home',
  },
  {
    path: '/mobile',
    name: 'mobile',

    component: () => import('../views/Mobile.vue')
  },
  {
    path: '/desktop',
    name: 'desktop',
    component: () => import('../views/Desktop.vue')
  },
  {
    path: '/report',
    name: 'report',
    component: () => import('../views/Report.vue')
  },
  {
    path: '/pdf',
    name: 'pdf',
    component: () => import('../views/pdf.vue')
  },
  {
    path: '/ifk_mobile',
    name: 'ifk_mobile',
    component: () => import('../views/IfkMobile.vue')
  }
]



const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  setTimeout(() => {
    if (to.path == "/desktop") {
      if (window.screen.width <= 640 || window.screen.width < window.screen.height) {
        next({ path: '/mobile', query: to.query })
        return
      }
    } else if (to.path == "/mobile") {
      if (window.screen.width > 640 && window.screen.width > window.screen.height) {
        next({ path: '/desktop', query: to.query })
        return
      }
    } else if (to.path == "/report") {
      // next({ path: '/report', query: to.query })
    }  else if (to.path == "/pdf") {
      // next({ path: '/report', query: to.query })
    } else if(to.path == "/ifk_mobile"){
      // next({ path: '/ifk_mobile', query: to.query })
    } else {
      if (window.screen.width <= 640 || window.screen.width < window.screen.height) {
        next({ path: '/mobile', query: to.query })
      } else {
        next({ path: '/desktop', query: to.query })
      }
    }
    next()
  }, 200);
})

export default router
